export const getTicketTable = (state) => {
  return state.ticketTable;
};

export const getDepartmentId = (state) => {
  const { departmentId } = getTicketTable(state);
  return departmentId;
};

export const getDistrictId = (state) => {
  const { districtId } = getTicketTable(state);
  return districtId;
};

export const getJobTicketNumber = (state) => {
  const { jobTicketNumber } = getTicketTable(state);
  return jobTicketNumber;
};

export const getOperatorId = (state) => {
  const { operatorId } = getTicketTable(state);
  return operatorId;
};

export const getLeaseId = (state) => {
  const { leaseId } = getTicketTable(state);
  return leaseId;
};

export const getPageSize = (state) => {
  const { pageSize } = getTicketTable(state);
  return pageSize;
};

export const getSorted = (state) => {
  const { sorted } = getTicketTable(state);
  return sorted;
};

/* NOTE: selectors for the cursorObjects */
export const getPrevCursorObject = (state) => {
  const { prevCursorObject } = getTicketTable(state);
  return prevCursorObject;
};

export const getNextCursorObject = (state) => {
  const { nextCursorObject } = getTicketTable(state);
  return nextCursorObject;
};

export const getFirstPageSize = (state) => {
  const { first } = getNextCursorObject(state);
  return first;
};

export const getBeforePageSize = (state) => {
  const { last } = getPrevCursorObject(state);
  return last;
};

export const getNextCursor = (state) => {
  const { cursorPosition } = getNextCursorObject(state);
  return cursorPosition;
};

export const getPrevCursor = (state) => {
  const { cursorPosition } = getPrevCursorObject(state);
  return cursorPosition;
};

export const getDateOrder = (state) => {
  const { dateOrderBy } = getTicketTable(state);
  return dateOrderBy;
};
